export const initialState = {
  loadingStatus: {
    packageListLoading: false,
    packageDetailLoading: false,
    createPackageLoading: false,
    updatePackageLoading: false,
    assessmentListLoading: false,
  },
  error: '',
  packageList: {
    data: [],
    offset: 0,
    limit: 0,
    total: 0,
  },
  packageDetail: {
    packageGroup: null,
  },

  //Assessment
  assessmentList: [],
};
